import React from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import { ChevronDownIcon } from '@radix-ui/react-icons';

import 'react-accessible-accordion/dist/fancy-example.css';

import { AccordionCardStoryblok } from '../../../../types/storyblok';
import classNames from 'classnames';
import Markup from '../../../../base/Markup/Markup';
import { Type } from '../../../../base/Type/Type';
import { Button } from '../../../../base/Button/Button';

const AccordionCard = ({
  title,
  richText,
  _uid,
  props,
}: AccordionCardStoryblok) => {
  return (
    <Accordion.Item value={_uid}>
      <Accordion.Header className="flex">
        <Accordion.Trigger
          className={classNames(
            'ff-divider ff-button--naked-arrow-right group relative flex flex-1 cursor-default items-center justify-between border-0 border-t p-6 text-left outline-none'
          )}
          {...props}
        >
          <Type as="span" className="text-h4 leading-none">
            {title}
          </Type>
          <Button
            type="button"
            variant="naked-arrow-right"
            className="rotate-90 group-data-[state=open]:-rotate-90"
          />
        </Accordion.Trigger>
      </Accordion.Header>
      <Accordion.Content
        className={classNames(
          'data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp overflow-hidden p-6 pt-0'
        )}
        {...props}
      >
        <Markup content={richText} className="text-p1" />
      </Accordion.Content>
    </Accordion.Item>
  );
};

export default AccordionCard;
